import capitalize from '../filters/capitalize';
import uppercase from '../filters/uppercase';
import lowercase from '../filters/lowercase';
import truncate from '../filters/truncate';

export default {
    data() {
        return {}
    },
    filters: {
        capitalize,
        uppercase,
        lowercase,
        truncate
    },
    methods: {
         lowerize(value) {
            return this.$options.filters.lowercase(value);
        },

        upperize(value) {
            return this.$options.filters.uppercase(value);
        },

        stripTags(str) {
            if (str === null || str === '' || str === undefined) {
                return false;
            }
            str = str.toString();
            return str.replace(/<[^>]*>/g, '');
        },

        capitalize(value) {
            return this.$options.filters.capitalize(value);
        },

        truncate(value, length) {
            value = this.stripTags(value);
            return this.$options.filters.truncate(value, length);
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/StringsMixin.js